import { Translation } from "../i18n-types";

const de: Translation = {
    "state-is-required": "State is required field.",
    description: {
        "show-more": "Zeig mehr",
        "show-less": "Zeige weniger"
    },
    footer: {
        "why-shop-with-us": "Warum kaufen Sie, in Ihren Worten, bei uns ein?",
        "heureka-image-url": "/footer/img/de/comparator.png",
        benefits: {
            first: "Super schnelle Lieferung",
            second: "Sehr schneller und zuverlässiger Service",
            third: "Freundliche Kundenbetreuung"
        },
        social: {
            "facebook-plugin-url":
                "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFoxigyde-110413114745860&tabs&width=314&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
            "facebook-page-url": "https://www.facebook.com/Foxigyde-110413114745860",
            "instagram-page-url": "https://www.instagram.com/foxigy.de/",
            "youtube-page-url": "https://www.youtube.com/channel/UC6qkYt_ZRKackfiB8acVHpA"
        },
        "your-foxigy-image-link": "/footer/img/de/your-foxigy.png"
    }
};

export default de;
